"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledSubtext = exports.StyledImage = exports.StyledContainer = exports.StyledCaption = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _ty = _interopRequireDefault(require("../../framework/ty"));

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

var StyledCaption = _styledComponents["default"].p.withConfig({
  displayName: "Avatarstyles__StyledCaption",
  componentId: "sc-1rwunxw-0"
})(["", " white-space:pre-line;"], (0, _ty["default"])(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["", ""])), function (_ref) {
  var _ref$theme$avatar = _ref.theme.avatar;
  _ref$theme$avatar = _ref$theme$avatar === void 0 ? {} : _ref$theme$avatar;
  var caption = _ref$theme$avatar.caption;
  return caption;
}));

exports.StyledCaption = StyledCaption;

var StyledContainer = _styledComponents["default"].div.withConfig({
  displayName: "Avatarstyles__StyledContainer",
  componentId: "sc-1rwunxw-1"
})(["", " ", ""], (0, _ty["default"])(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["inline-flex flex-column tc w-100"]))), function (_ref2) {
  var avatar = _ref2.theme.avatar;
  return "\n    max-width: ".concat(avatar === null || avatar === void 0 ? void 0 : avatar.size, ";\n  ");
});

exports.StyledContainer = StyledContainer;

var StyledImage = _styledComponents["default"].img.withConfig({
  displayName: "Avatarstyles__StyledImage",
  componentId: "sc-1rwunxw-2"
})(["", " ", " object-fit:cover;box-sizing:border-box;"], (0, _ty["default"])(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])(["br-pill w-100 mb3\n    ", "\n    ", "\n  "])), function (_ref3) {
  var avatar = _ref3.theme.avatar;
  return (avatar === null || avatar === void 0 ? void 0 : avatar.borderWidth) > 0 ? "bw".concat(avatar === null || avatar === void 0 ? void 0 : avatar.borderWidth, " b--solid") : '';
}, function (_ref4) {
  var avatar = _ref4.theme.avatar;
  return "b--".concat(avatar === null || avatar === void 0 ? void 0 : avatar.color);
}), function (_ref5) {
  var avatar = _ref5.theme.avatar;
  return "\n    max-width: ".concat(avatar === null || avatar === void 0 ? void 0 : avatar.size, ";\n    max-height: ").concat(avatar === null || avatar === void 0 ? void 0 : avatar.size, ";\n  ");
});

exports.StyledImage = StyledImage;

var StyledSubtext = _styledComponents["default"].p.withConfig({
  displayName: "Avatarstyles__StyledSubtext",
  componentId: "sc-1rwunxw-3"
})(["", " white-space:pre-line;"], (0, _ty["default"])(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2["default"])(["", ""])), function (_ref6) {
  var avatar = _ref6.theme.avatar;
  return avatar === null || avatar === void 0 ? void 0 : avatar.subtext;
}));

exports.StyledSubtext = StyledSubtext;